export default function ($http) {
    return function () {
        return $http({
            method: 'GET',
            url: `/api/users/me`,
            headers: {
                'Content-Type': 'application/json'
            }
        })
		.then(result => result.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/account/services/details/accountDetails.js